import CellEditor from './CellEditor.component';

export default {
  cellEditor: CellEditor,
};
